<template>
  <div class="slot col-6 col-sm-4 col-lg-3 col-xl-2 py-1 px-2">
    <a href="#" class="btn btn-outline-secondary shadow-sm border-light js-time" @click.prevent="$emit('choose', s.slots)">
      {{ displayTime(s.label) }}
      <span class="badge badge-pill badge-lightish ml-1" v-if="s.count > 1">{{ s.count }}</span>
    </a>
  </div>
</template>

<script charset="utf-8">
export default {
  name: "TimeSlot",
  props: ["s", "slots"],

  methods: {
    displayTime(label) {
      // If appointmentTimezoneToUse == "browser", then we need to convert to the browser's timezone
      // otherwise, we use organisation timezone
      const timeStart = moment(this.s.slots[0].ts * 1000);

      const timeStartSlot = appointmentTimezoneToUse == "browser" ? timeStart : timeStart.tz(organizationTimezoneLabel);
      return timeStartSlot.format("h:mma");
    },
  },
};
</script>
